import React from 'react';

const MongoDB_Find = () => {
  return (
    <div>
      <h1>MongoDB_Find Component</h1>
      <p>This is the MongoDB_Find page.</p>
    </div>
  );
};

export default MongoDB_Find;
